import { Box, Checkbox, CircularProgress, FormControlLabel, Typography } from '@mui/material';
import { BuilderBox } from '../../../types/SimilarlySituated/BuilderBox.type.ts';

export interface BuildSelectionItemProps {
  build: BuilderBox;
  onBuildSelect: (build: BuilderBox) => void;
  updateBuildMutation: (data: { buildId: number; pinned: boolean }) => void;
  isUpdatingBuild?: boolean;
}

function BuildSelectionItem({ build, onBuildSelect, updateBuildMutation, isUpdatingBuild }: BuildSelectionItemProps) {
  const caseTypeBoxes = build.condition_boxes.filter((conditionBox) => !conditionBox.is_exclude);
  const conditionCount = build.condition_boxes.reduce(
    (total, conditionBox) => total + conditionBox.conditions.length,
    0,
  );

  const summary = [
    `${caseTypeBoxes.length} case ${caseTypeBoxes.length === 1 ? 'type' : 'types'}`,
    `${conditionCount} ${conditionCount === 1 ? 'condition' : 'conditions'}`,
  ].join(' · ');

  const handleCheckboxClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
  };

  return (
    <Box
      onClick={() => onBuildSelect(build)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid #e2e8f0',
        cursor: 'pointer',
        borderRadius: '6px',
        paddingX: '20px',
        paddingY: '28px',
        '&:hover': { borderColor: 'accentBlue.main' },
      }}
    >
      <FormControlLabel
        control={
          isUpdatingBuild ? (
            <CircularProgress size={26} sx={{ marginX: '10px' }} />
          ) : (
            <Checkbox
              onChange={() => updateBuildMutation({ buildId: build.id, pinned: !build.pinned })}
              onClick={handleCheckboxClick}
              checked={build.pinned}
              sx={{ margin: 0, '&.Mui-checked': { color: 'accentBlue.main' } }}
            />
          )
        }
        label={
          <Box onClick={(e) => e.preventDefault()}>
            <Typography variant='body1' sx={{ fontWeight: 600, color: '#2d3748' }}>
              {build.name}
            </Typography>
            <Typography variant='body2' sx={{ fontSize: '12px', color: '#718096' }}>
              {summary}
            </Typography>
          </Box>
        }
      />
    </Box>
  );
}

export default BuildSelectionItem;
